<main id="statusnotifications-table">
  <div class="card">
    <div class="card-header">
      <div class="row card-title mb-0 pb-0">
        <div class="col-12 mb-0">
            <div class="h5 float-start mb-0 pb-0" i18n="@@StatusNotificationsHeader"><app-svg source="icons/feather/alert-triangle" height="18" class="me-2"></app-svg>Statusmeldungen</div>
            <!--<div class="float-end mb-0 pb-0">
              <div ngbDropdown #notificationMail="ngbDropdown" id="notificationMail" placement="bottom-right" auto-close="outside" class="mb-0 pb-0">
                <button ngbDropdownToggle class="btn btn-yellow ms-1 pe-0 pe-md-3" type="button">
                  <app-svg source="icons/feather/info" height="18"></app-svg>
                  <span class="d-none d-md-inline ps-2">Benachrichtigung</span>
                </button>

                <div ngbDropdownMenu class="notificationSend p-3">
                  <form [formGroup]="formService.form" *ngIf="formService.formCreated">
                    <p class="small text-muted">Mit dieser Funktion werden alle Ausfälle die länger als 3 Stunden anhalten, als Benachrichtigung an die angegebene E-Mailadresse gesendet.</p>
                    
                    <div class="form-group">
                      <input type="checkbox" id="notificationSend" class="ml-0 form-check-input pr-2"
                             formControlName="notificationSend" (change)="notification()">
                      <label for="notificationSend" class="label ms-4 ps-2 no-wrap " i18n="@@NotificationActivated">
                        Benachrichtigung aktivieren?
                      </label>
                    </div>
                    <div class="form-group">
                      <label for="mailaddress">E-Mailadresse</label>
                      <input type="email" id="mailaddress" class="form-control" formControlName="mailaddress" [readonly]="true" />
                    </div>
                    <div class="form-group float-end">
                      <button type="button" class="btn btn-yellow" (click)="saveNotificationSendStatus()">Speichern</button>
                    </div>
                  </form>


                </div>

              </div>
            </div>-->
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="clearfix">
        <form class="float-start">
          <div i18n="@@Search" style="min-width:200px;">
            <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
          </div>
        </form>
        <div class="float-end mb-1">
          <app-table-filter [defaultFilter]='{"entries":"1000"}' (setFilterEvent)="setFilter($event)"></app-table-filter>
        </div>
      </div>
      <div *ngIf="tableReady" [class]="tableView">
        <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()"
                    [class]="tableFunctions.getTableLayout(className)"></app-table>
      </div>

      <div *ngIf="!tableReady" class="loading-spinner-container">
        <div class="spinner-border text-primary loading-spinner-md" role="status">
          <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
        </div>
      </div>
    </div>
  <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
    <div class="d-flex">
      <div class="flex-fill d-none d-md-inline">
        <div class="d-flex">
          <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
          <div class="flex">
            <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                    class="form-control form-select custom-select" aria-label=""
                    (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
              <option [ngValue]="250">250</option>
            </select>
          </div>
        </div>
      </div>

      <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
        <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!"
                        [(page)]="tableFunctions.page" [pageSize]="tableFunctions.pageSize"
                        [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true" [rotate]="true">
        </ngb-pagination>
      </div>

      <div class="flex-fill justify-content-end d-none d-md-inline">
        <div class="d-flex float-end">
          <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
          <div class="flex">
            <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
                    aria-label="">
              <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index"
                      [ngValue]="i + 1">
                {{ i + 1 }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
    </div>
</main>
<router-outlet></router-outlet>
